import { useAllExperiments } from '@app/experiments';
import { useMemo } from 'react';
import type { LanguageObject } from '../types';
import { LANGUAGES } from '../data';

/**
 *
 */
const useLanguageOptions = (): LanguageObject[] => {
  const experiments = useAllExperiments();
  return useMemo(
    () =>
      Object.values(LANGUAGES).filter((language) => {
        // filter inactive languages
        if (!language.active) {
          return false;
        }

        // filter languages that aren't enabled due to experiments.
        return !(language.experiment && !experiments[language.experiment]);
      }),
    [experiments],
  );
};

export default useLanguageOptions;
